<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title18"></a>
<div class="p-c-br"><span>For my husband, David, who, <br/>after twenty books, is still supportive, <br/>still indulgent and still cooking. <br/>I couldn’t have done it without you. <br/>Here’s to twenty more.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c-br"><span>And with much, much gratitude to <br/>Captain George Meyers (AKA Roscoe) of <br/>Chicago, Illinois, who, happily and with great humor, <br/>answered an exhaustive list of questions about his fire- <br/>fighting profession, and who added more than a little <br/>color to the book as a result. Any inaccuracies that may <br/>appear in the story do so because of my own <br/>erroneously drawn conclusions. <br/>Thanks, George!</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459271517_ded01.vue?44298a53